import React, { useState } from 'react'
import { Row, Typography, Card } from 'antd'
import { EmptyHeaderHero, GlobalHeader, GlobalFooter } from './components'
import RoundyModal from './RoundyModal/RoundyModal'
import ExpressStyle from '../../styles/ExpressPolicyChanges.module.css'

const { Link, Text } = Typography

const ExpressPolicyChanges = () => {
  const [isRemoveVehicleModalOpen, setIsRemoveVehicleModalOpen] = useState(false);
  const [isAddVehicleModalOpen, setIsAddVehicleModalOpen] = useState(false);

  const showRemoveVehicleModal = () => {
    setIsRemoveVehicleModalOpen(true);
  };

  const showAddVehicleModal = () => {
    setIsAddVehicleModalOpen(true);
  };

  const handleOk = () => {
    window.location = "/my-account";
  };

  const handleRemoveVehicleCancel = () => {
    setIsRemoveVehicleModalOpen(false);
  };

  const handleAddVehicleCancel = () => {
    setIsAddVehicleModalOpen(false);
  };

  const subTitle = (
    <Text className={`${ExpressStyle["express-policy-changes-sub-title"]}`}>
      {' '}
      (Please note: Not for agency use or same-day coverage requests.)
    </Text>
  )

  return (
    <div className="container">
      <GlobalHeader />
      <>
        <EmptyHeaderHero leftAlign={true} minHeight={true} subTitle={subTitle} title="Express Policy Changes" />
        <div className={`${ExpressStyle["express-policy-changes"]}`}>
          <Row>
            <Card className={`${ExpressStyle["express-card"]}`}>
              <p>If you would like to make a vehicle change to your policy and get your ID cards right away, you can do so in <a href="/my-account"><u>My Account</u></a>.</p>

              <Text className={`${ExpressStyle["sub-text"]} ${ExpressStyle["margin-top-18"]}`}>Vehicle Changes</Text>
              <Link className={`${ExpressStyle["link-text"]}`} onClick={showAddVehicleModal}>
                Add Vehicle
              </Link>
              <br />
              <Link className={`${ExpressStyle["link-text"]}`} onClick={showRemoveVehicleModal}>
                Remove Vehicle
              </Link> 
              <br />
              <br />
              <p>If you would like to update your address or make any household changes, please call us at <a href="tel:+1800-535-2873"><u>800-535-2873</u></a>.</p>
              
              <br />
            </Card>
          </Row>
        </div>
      </>
      <RoundyModal
        isModalOpen={isRemoveVehicleModalOpen}
        handleOk={handleOk}
        handleCancel={handleRemoveVehicleCancel}
        title="Remove Vehicle"
        content="If you would like to remove a vehicle from your policy and get your ID Cards right away, you can do so in My Account. Click log in to continue."
        okText="LOG IN"
      />
      <RoundyModal
        isModalOpen={isAddVehicleModalOpen}
        handleOk={handleOk}
        handleCancel={handleAddVehicleCancel}
        title="Add Vehicle"
        content="If you would like to add a vehicle to your policy and get your ID Cards right away, you can do so in My Account. Click log in to continue."
        okText="LOG IN"
      />
      <GlobalFooter />
    </div>
  )
}

ExpressPolicyChanges.propTypes = {}

export default ExpressPolicyChanges
